import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const createSvgIcon = (SvgComponent, displayName, viewBox) => {
  // eslint-disable-next-line react/prop-types
  const Component = ({ svgProps, ...props }, ref) => (
    <SvgIcon
      aria-label={`${displayName} Icon`}
      data-testid={`${displayName}Icon`}
      viewBox={viewBox}
      ref={ref}
      {...props}
    >
      <SvgComponent {...svgProps} />
    </SvgIcon>
  );

  return React.memo(React.forwardRef(Component));
};

export default createSvgIcon;
